import React, {memo} from "react";
import {Modal} from 'react-bootstrap';
const BaseModalSmall = (props) => {
    const {title,children,show,handleClose,dialogClassName} = props;
    return (
        <>
            <Modal dir={'rtl'} show={show} onHide={handleClose} centered={true} dialogClassName={typeof dialogClassName === undefined ? 'modal-base-sm-custom' : 'modal-base-sm-custom '+dialogClassName}>
                <Modal.Header closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                {children}
            </Modal>
        </>
    )
};

export default memo(BaseModalSmall);
